import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import styles from "./Login.module.css"; // reuse same styles for coherence
import msgStyles from "../components/Messages.module.css";

function Signup() {

    const [form, setForm] = useState({ username: "", email: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false); // Added loading state
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth(); // Your AuthContext's login function

    const from = location.state?.from?.pathname || "/";

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Set loading to true on submission
        setError(""); // Clear previous errors
        try {
            // Send username, email, and password to the backend registration endpoint
            const res = await axios.post("https://deenroute-backend-908197786741.africa-south1.run.app/api/auth/register", form);


            const userData = {
                uid: res.data.uid,
                username: res.data.username,
                email: res.data.email,
                score: res.data.score,
                token: res.data.token,
            };


            login(userData.token, userData.uid, userData.username, userData.email, userData.score);

            navigate(from, { replace: true }); // Redirect back to intended page or home
        } catch (err) {

            setError(err.response?.data?.error || "Signup failed. Please try again.");
            console.error("Signup API call failed:", err.response ? err.response.data : err.message, err);
        } finally {
            setLoading(false); // Always set loading to false after attempt
        }
    };

    return (
        <div
            className={styles.background}
            style={{ backgroundImage: `url("/images/loginsignup.jpg")` }}
        >
            <div className={styles.overlay}></div>
            <div className={styles.container}>
                <h2 className={styles.title}>Signup</h2>
                {error && <p className={msgStyles.error}>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <input
                        className={styles.input}
                        type="text"
                        name="username"
                        placeholder="Username"
                        value={form.username}
                        onChange={handleChange}
                        required
                    />
                    <input
                        className={styles.input}
                        type="email" // Changed type to email for better validation
                        name="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleChange}
                        required
                    />
                    <input
                        className={styles.input}
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={form.password}
                        onChange={handleChange}
                        required
                    />
                    <button type="submit" className={styles.button} disabled={loading}>
                        {loading ? "Signing Up..." : "Sign Up"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Signup;